module.exports = __webpack_public_path__ + "4d68684570ae358381198c4bc840d4e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201509_rn_1.jpg
// module id = 636
// module chunks = 0